/* eslint-disable @typescript-eslint/naming-convention */
export namespace StatutPhotoExtraction {
    export type StatutEnum = 'Aucune' | 'EnCours' | 'Disponible';
    export const StatutEnum = {
        Aucune: 'Aucune' as StatutEnum,
        EnCours: 'En cours' as StatutEnum,
        Disponible: 'Disponible' as StatutEnum
    };
}
